/** @jsxImportSource @emotion/react */

import { Dispatch, FC, SetStateAction } from 'react'
import { findAllRecommendedArticleGroup_findAllRecommendedArticleGroup_items as IGroup } from '__generatedTypes__/findAllRecommendedArticleGroup'
import { SubjectExtendedFull } from 'hooks/usePlatformsAndSubjects'
import RecommendedArticlesGroups from './RecommendedArticlesGroups'
import RecommendedArticlesTabs from './RecommendedArticlesTabs'

interface IProps {
  selectedSubject: SubjectExtendedFull
  groups: IGroup[]
  setGroups: Dispatch<SetStateAction<IGroup[]>>
}

const RecommendedArticlesContent: FC<IProps> = ({ selectedSubject, groups, setGroups }) => (
  <>
    <RecommendedArticlesGroups groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    {groups.length > 0 && (
      <RecommendedArticlesTabs groups={groups} selectedSubjectId={selectedSubject.id} initialSelected={groups[0]} />
    )}
  </>
)

export default RecommendedArticlesContent
